export enum CookieName {
  AUTH = "auth",
  REFRESH = "refresh",
}

/**
 * localstorage 이름
 * @see CONTENT_BOOKMARK 번역 컨텐츠 책갈피 기능
 */
export enum LocalName {
  CONTENT_BOOKMARK = "CONTENT_BOOKMARK",
}
